import { uplayConstants } from '../constants'
import { uplayService } from '../../services'
import { request, success, failure } from './helper'

let checkAuthenticatedPromise = null
let checkAuthenticatedTicket = null

function login(ticket) {
  return dispatch => {
    if (ticket) {
      dispatch(success(uplayConstants.UPLAY_AUTHENTICATE_SUCCESS, { ticket }))
    } else {
      dispatch(failure(uplayConstants.UPLAY_AUTHENTICATE_FAILURE))
    }
  }
}

function checkAuthenticated() {
  const ticket = uplayService.getUserTicket()

  return async dispatch => {
    if (!ticket) {
      dispatch(failure(uplayConstants.UPLAY_CHECK_AUTHENTICATE_FAILURE))
      return Promise.resolve()
    }

    if (checkAuthenticatedPromise && checkAuthenticatedTicket === ticket) {
      return checkAuthenticatedPromise
    }

    checkAuthenticatedTicket = ticket
    checkAuthenticatedPromise = uplayService
      .verifyUserUplayTicket(ticket)
      .then(() => dispatch(success(uplayConstants.UPLAY_CHECK_AUTHENTICATE_SUCCESS)))
      .catch(error => dispatch(failure(uplayConstants.UPLAY_CHECK_AUTHENTICATE_FAILURE, error)))
      .finally(() => {
        checkAuthenticatedPromise = null
        checkAuthenticatedTicket = null
      })

    return checkAuthenticatedPromise
  }
}

function activateGame(activationKey, contentId, couponCode) {
  const ticket = uplayService.getUserTicket()

  return async dispatch => {
    dispatch(request(uplayConstants.UPLAY_ACTIVATE_GAME_REQUEST))
    try {
      await uplayService.activateGame(ticket, activationKey, contentId, couponCode)
      dispatch(success(uplayConstants.UPLAY_ACTIVATE_GAME_SUCCESS))
      dispatch(success(uplayConstants.UPLAY_LOGOUT_SUCCESS))
    } catch (error) {
      dispatch(failure(uplayConstants.UPLAY_ACTIVATE_GAME_FAILURE, error))
      throw error
    }
  }
}

export default {
  activateGame,
  login,
  checkAuthenticated,
}
